import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/layout/Footer';
const TermsConditions: React.FC = () => {
  return (
    <div className="bg-white">
      <Navbar />

      <div className="pt-24 pb-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      
      <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
      <p className="mb-6">
        <strong>Effective Date:</strong> April 2025<br />
        <strong>Last Updated:</strong> April 2025
      </p>
      <p className="mb-6">Welcome to Atompass. These Terms of Service (“Terms”) govern your use of the Atompass Chrome Extension and web platform. By using our service, you agree to these terms.</p>

      
      <div className="prose prose-lg max-w-none">
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">1. Use of the Service</h2>
          <p>
            Atompass is a secure password and data manager. You agree to use it lawfully and according to these terms.
          </p>
        </section>
        
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">2. Your Account</h2>
          <ul className="list-disc pl-6 mb-4">
            <li>You must keep your master password confidential.</li>
            <li>You are responsible for activities under your account.</li>
            <li>Providing false information may result in termination.</li>
          </ul>
        </section>
        
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">3. Data Encryption</h2>
          <p>
            Your passwords and notes are encrypted and can only be decrypted using your master password. We cannot recover lost master passwords.
          </p>
        </section>
        
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">4. Payment</h2>
          <p>
            Atompass is a paid service via one-time purchase through Stripe. No free tier is available. Refunds are not guaranteed unless required by law.
          </p>
        </section>
        
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">5. Termination</h2>
          <p>
            We may suspend or terminate your account for violations, misuse, or technical risks.
          </p>
        </section>
        
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">6. Intellectual Property</h2>
          <p>
            All content and branding are owned by our legal entity. Reuse or reproduction is not permitted without written permission.
          </p>
        </section>
        
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">7. Limitation of Liability</h2>
          <p>
            We do not guarantee error-free service. We are not liable for data loss, outages, or unauthorized access. Use is at your own risk.
          </p>
        </section>
        
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">8. Governing Law</h2>
          <p>
            These terms are governed by the laws of your jurisdiction. Disputes will be resolved in courts located in your registered region.
          </p>
        </section>
        
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">9. Contact</h2>
          <p>
            Email: <a href="mailto:support@atompass.com" className="text-blue-600">support@atompass.com</a><br />
            Website: <a href="https://atompass.com" className="text-blue-600">https://atompass.com</a>
          </p>
        </section>
      </div>
    </div>
    </div>
    <Footer />
    </div>
  );
};

export default TermsConditions; 